import Link from 'src/components/ui/Link'
import { mark } from 'src/sdk/tests/mark'

import type {
  BannerCategoryPlpProps,
  BannersCategoryPlpProps,
} from './banner-category-plp'
import './bannercategoryplp.scss'
import { getCustomStylesImage, getCustomStylesText } from './utils'

const getElementByStyles = ({ banners }: BannersCategoryPlpProps) =>
  banners.map((banner: BannerCategoryPlpProps, index: number) => {
    const { image, subtitle } = banner
    const customStylesImage = getCustomStylesImage(image?.styles)
    const customStylesText = getCustomStylesText(subtitle?.styles)

    return (
      <Link as="a" href={subtitle?.href} key={index}>
        <button className="category__bannerplp-button">
          <img
            src={image?.src}
            alt={image?.alt ?? 'Banner plp'}
            className="category__bannerplp-img"
            style={customStylesImage}
          />
          <p className="category__bannerplp-title" style={customStylesText}>
            {subtitle?.label}
          </p>
        </button>
      </Link>
    )
  })

function BannerCategoryPlp({
  banners,
  marginTop,
  marginBottom,
}: BannersCategoryPlpProps) {
  return (
    <>
      <div
        className="category__bannerplp-section"
        style={{ marginTop: `${marginTop}`, marginBottom: `${marginBottom}` }}
      >
        {getElementByStyles({ banners })}
      </div>
    </>
  )
}

export default mark(BannerCategoryPlp)
